<template>
	<div class="container mt-3">
		<div class="row">
			<div class="col-12">
				<div class="image_banner_container"
				v-for="(promotion, index) in promotions"
				:key="index">
					<img
						alt="Deals of the day image"
						class="deal-img"
						v-lazy="promotion.image_url"
						:id="'imageBanner'+index"
						:data-test="'imageBanner'+index"
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'image-banner',
	computed: {
		...mapGetters('promotions', ['getAllPromotions']),
		promotions () {
			return this.getAllPromotions.filter(promotion =>
				promotion.promotion_type === 'Banner')
		}
	}
}
</script>

<style scoped>

</style>
